<template>
  <div class="tc-page">
    <header class="tc-page__hero">
      <div class="tc-page__hero-text">
        <h1 class="tc-page__title">Жагсаалт</h1>
        <p class="tc-page__subtitle">Трак код хайж, төлөвөөр шүүнэ үү</p>
      </div>
      <div v-if="!callDeliveryComponent && totalRecords" class="tc-page__count">
        <span class="tc-page__count-num">{{ totalRecords }}</span>
        <span class="tc-page__count-label">бүртгэл</span>
      </div>
    </header>

    <div class="tc-page__toolbar">
      <div class="tc-page__search">
        <el-input
          v-if="checkPermissionsPage('app_list_search_mongolia') && callDeliveryComponent"
          v-model="searchQuery"
          placeholder="Утасны дугаараар хайх"
          size="medium"
          clearable
          prefix-icon="el-icon-search"
          @clear="clearSearch"
          @keyup.enter.native="searchItemDelivery"
        />
        <el-input
          v-else-if="checkPermissionsPage('app_list_search_china')"
          v-model="searchQuery"
          placeholder="Трак код оруулна уу"
          size="medium"
          clearable
          prefix-icon="el-icon-search"
          @clear="clearSearch"
          @keyup.enter.native="searchItem"
        />
        <el-input
          v-else-if="checkPermissionsPage('app_list_search_mongolia')"
          v-model="searchQuery"
          placeholder="Утас эсвэл track code..."
          size="medium"
          clearable
          prefix-icon="el-icon-search"
          @clear="clearSearch"
          @keyup.enter.native="searchItem"
        />
        <el-button
          v-if="callDeliveryComponent"
          type="primary"
          size="medium"
          icon="el-icon-search"
          @click="searchItemDelivery"
        >
          Хайх
        </el-button>
        <el-button
          v-else
          type="primary"
          size="medium"
          icon="el-icon-search"
          @click="searchItem"
        >
          Хайх
        </el-button>
      </div>
    </div>

    <div v-if="filterOptions.length" class="tc-page__filters">
      <span class="tc-page__filters-label">Төлөв</span>
      <div class="tc-page__filter-chips">
        <button
          type="button"
          class="tc-chip"
          :class="{ 'tc-chip--active': !transacProgressCode }"
          @click="clearFilter"
        >
          Бүгд
        </button>
        <button
          v-for="opt in filterOptions"
          :key="opt.value"
          type="button"
          class="tc-chip"
          :class="{ 'tc-chip--active': String(transacProgressCode) === String(opt.value) }"
          @click="applyFilter(opt.value)"
        >
          {{ opt.label }}
        </button>
      </div>
    </div>

    <div
      v-if="!callDeliveryComponent && formData.selectedTrackCodes.length && checkProgressCode()"
      class="tc-page__actions"
    >
      <el-button
        v-if="isPaid === false && checkPermissionsPage('admin')"
        size="small"
        type="primary"
        @click="openProgressDialog('pay', null)"
      >
        Төлбөр төлөх
      </el-button>
      <el-button
        v-if="isPaid === false && checkPermissionsPage('admin')"
        size="small"
        type="success"
        @click="openProgressDialog('payAndGive', null)"
      >
        Төлбөр төлөх | олгох
      </el-button>
      <el-button
        v-if="isPaid === true && (checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch'))"
        size="small"
        type="success"
        @click="openProgressDialog('give', null)"
      >
        Хэрэглэгчид олгох
      </el-button>
      <el-button
        v-if="checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch')"
        size="small"
        type="warning"
        @click="openProgressDialog('delivery', null)"
      >
        Хүргэлтэнд гаргах
      </el-button>
    </div>

    <div
      v-if="!callDeliveryComponent && (checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch'))"
      class="tc-page__summary"
    >
      <div class="tc-page__summary-left">
        <el-checkbox class="tc-check-all" @change="checkAll">Бүгдийг сонгох</el-checkbox>
      </div>
      <div class="tc-page__summary-right">
        <span>Сонгосон: <b>{{ formData.countTrackCode }}</b></span>
        <span>Нийт үнэ: <b>{{ formData.totalPrice | formatCurrency }}</b></span>
      </div>
    </div>

    <div v-if="callDeliveryComponent">
      <DeliveryComponent
        ref="deliveryComponent"
        :progressCode="transacProgressCode"
        @refreshDeliveryList="resetAndFetch"
      />
    </div>

    <template v-else>
      <el-empty
        v-if="!items.length && !$root.fullscreenLoading"
        class="tc-page__empty"
        description="Трак код олдсонгүй"
        :image-size="80"
      />

      <div v-else class="tc-card-list">
        <el-card
          v-for="(item, index) in items"
          :key="item.track_code || item.id || index"
          class="tc-card"
          shadow="hover"
          :body-style="{ padding: '0' }"
        >
          <div
            class="tc-card__accent"
            :class="'tc-card__accent--' + statusAccentClass(item.progress_code)"
          />
          <div class="tc-card__body">
            <div class="tc-card__head">
              <div class="tc-card__code-wrap">
                <template v-if="item.progress_code === 200 || checkPermissionsPage('erlian_branch')">
                  <span class="tc-card__code">{{ item.track_code }}</span>
                </template>
                <el-checkbox
                  v-else-if="checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch')"
                  class="tc-card__check"
                  :label="item.track_code"
                  v-model="formData.selectedTrackCodes"
                  @change="handlePrice(item)"
                >
                  {{ item.track_code }}
                </el-checkbox>
                <span v-else class="tc-card__code">{{ item.track_code }}</span>
              </div>
              <el-tag
                v-if="item.progress_code"
                :type="statusTagType(item.progress_code)"
                size="small"
                effect="dark"
                class="tc-card__tag"
              >
                {{ returnStatusValue(item.progress_code) }}
              </el-tag>
            </div>

            <div class="tc-card__meta" @click="openProgressDialog('one', item)">
              <span v-if="item.progress_created_at" class="tc-card__date">
                {{ item.progress_created_at.split('T')[0] }}
              </span>
              <dl class="tc-card__dl">
                <div
                  v-if="item.phone_number && (checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch'))"
                  class="tc-card__row"
                >
                  <dt>Утас</dt>
                  <dd>
                    <a :href="'tel:' + item.phone_number" class="tc-card__phone" @click.stop>
                      {{ item.phone_number }}
                    </a>
                  </dd>
                </div>
                <div
                  v-if="item.taviur_code && (checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch'))"
                  class="tc-card__row"
                >
                  <dt>Тавиур</dt>
                  <dd>{{ item.taviur_code }}</dd>
                </div>
                <div
                  v-if="item.price && (checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch'))"
                  class="tc-card__row"
                >
                  <dt>Үнэ</dt>
                  <dd>{{ item.price | formatCurrency }}</dd>
                </div>
                <div
                  v-if="item.save_price && (checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch'))"
                  class="tc-card__row"
                >
                  <dt>Хадгалалт</dt>
                  <dd>{{ item.save_price | formatCurrency }}</dd>
                </div>
                <div
                  v-if="item.delivery_amount && String(transacProgressCode) === '130' && (checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch'))"
                  class="tc-card__row"
                >
                  <dt>Хүргэлт</dt>
                  <dd>{{ item.delivery_amount | formatCurrency }}</dd>
                </div>
                <div
                  v-if="item.irsen_salbariin_ner && (checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch'))"
                  class="tc-card__row"
                >
                  <dt>Салбар</dt>
                  <dd>{{ item.irsen_salbariin_ner }}</dd>
                </div>
                <div v-if="item.jin" class="tc-card__row">
                  <dt>Жин</dt>
                  <dd>{{ item.jin }}гр</dd>
                </div>
                <div v-if="item.config_type_name" class="tc-card__row">
                  <dt>Төрөл</dt>
                  <dd>{{ item.config_type_name }}</dd>
                </div>
                <div v-if="item.check_type" class="tc-card__row">
                  <dt>Төлөв</dt>
                  <dd>{{ checkTypeLabel(item.check_type) }}</dd>
                </div>
                <div class="tc-card__row">
                  <dt>Хэрэглэгч</dt>
                  <dd>
                    <span v-if="item.status === 'new'" class="tc-user--new">Шинэ</span>
                    <span v-else-if="item.status === 'old'" class="tc-user--old">Хуучин</span>
                    <span v-else class="tc-user--none">Бүртгэлгүй</span>
                  </dd>
                </div>
              </dl>
            </div>

            <div v-if="isPaid === false" class="tc-card__footer">
              <el-button
                class="tc-card__btn"
                size="small"
                type="primary"
                plain
                icon="el-icon-view"
                @click="openProgressDetailDialog(item.id)"
              >
                Дэлгэрэнгүй
              </el-button>
            </div>
          </div>
        </el-card>
      </div>

      <div v-if="!isSearchResults && items.length" class="tc-page__scroll-status">
        <div v-if="loadingMore" class="tc-page__loading-more">
          <i class="el-icon-loading" /> Уншиж байна...
        </div>
        <div v-else-if="finished" class="tc-page__end">
          Нийт {{ totalRecords }} · бүгдийг харуулсан
        </div>
        <div v-else class="tc-page__hint">
          {{ items.length }} / {{ totalRecords }} · доош гүйлгэж үргэлжлүүлнэ
        </div>
      </div>
      <div ref="scrollSentinel" class="tc-page__sentinel" aria-hidden="true" />

      <transition name="tc-fade">
        <div v-if="loadingMore" class="tc-scroll-loader" aria-live="polite">
          <div class="tc-scroll-loader__inner">
            <i class="el-icon-loading tc-scroll-loader__icon" />
            <span>Дараагийн хуудас ачаалж байна...</span>
          </div>
        </div>
      </transition>
    </template>

    <ProgressDialog
      v-if="$root.progressDialog"
      :checkedTrackCodes="formData"
      :search_query="searchQuery"
      @refreshData="emitFunction"
    />
    <ProgressDetailDialog
      v-if="$root.progressDetailDialog"
      :progressId="progress_id"
      @refreshData="emitFunction"
    />
  </div>
</template>

<script>
import services from '@/helpers/services'
import ProgressDialog from '@/views/Dialog/ProgressDialog.vue'
import DeliveryComponent from './DeliveryComponent.vue'
import { checkPermissions } from '@/helpers/custom'
import _ from 'lodash'
import ProgressDetailDialog from '@/views/Dialog/ProgressDetailDialog.vue'

export default {
  name: 'TrackCodeComponent',
  components: {
    ProgressDialog,
    DeliveryComponent,
    ProgressDetailDialog
  },
  props: {
    progressCode: {
      type: Array
    },
    isPaid: {
      type: Boolean
    }
  },
  data () {
    return {
      callDeliveryComponent: false,
      currentPage: 1,
      pageSize: 20,
      totalRecords: 0,
      isSearchResults: false,
      loadingMore: false,
      finished: false,
      items: [],
      groupedData: {},
      searchQuery: null,
      formData: {
        type: null,
        selectedTrackCodes: [],
        is_paid: false,
        paid_type: 'transaction',
        totalPrice: null,
        countTrackCode: 0,
        taviur_codes: [],
        deliveryAmount: 0,
        description: null,
        jin: 0,
        user_status: null,
        phone_number: [],
        save_price: 0
      },
      progress_code: null,
      transacProgressCode: null,
      progress_id: null,
      scrollObserver: null
    }
  },
  computed: {
    filterOptions () {
      const opts = []
      if (this.checkPermissionsPage('app_list_button_delivery')) {
        opts.push({ value: '130', label: 'Хүргэлтээр авна' })
      }
      if (this.checkPermissionsPage('view_check_track_code')) {
        opts.push({ value: '180', label: 'Шалгуулах' })
      }
      if (this.checkPermissionsPage('app_list_button_go_to_get')) {
        opts.push({ value: '140', label: 'Очиж авна' })
      }
      if (this.checkPermissionsPage('app_list_button_save')) {
        opts.push({ value: '150', label: 'Хадгалуулна' })
      }
      if (this.checkPermissionsPage('app_list_button_hvrgeltiin_ajiltand_huviaralsan')) {
        opts.push({ value: '160', label: 'Ажилтанд хуваарилсан' })
      }
      if (this.checkPermissionsPage('app_list_button_sachaa_salbar_deer_uldsen')) {
        opts.push({ value: '170', label: 'Салбар дээр үлдсэн' })
      }
      if (this.checkPermissionsPage('app_list_button_delivery')) {
        opts.push({ value: '210', label: 'Багцын ачаа' })
      }
      return opts
    }
  },
  watch: {
    '$root.progressDialog' (newVal) {
      if (!newVal) {
        this.formData.selectedTrackCodes = []
        this.formData.totalPrice = 0
        this.formData.countTrackCode = 0
        this.formData.phone_number = []
      }
    }
  },
  created () {
    this.resetAndFetch()
  },
  mounted () {
    this.setupScrollObserver()
  },
  beforeDestroy () {
    this.teardownScrollObserver()
  },
  methods: {
    setupScrollObserver () {
      this.teardownScrollObserver()
      if (typeof IntersectionObserver === 'undefined') {
        window.addEventListener('scroll', this.onWindowScroll, { passive: true })
        return
      }
      this.scrollObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0]
          if (entry && entry.isIntersecting) {
            this.loadMore()
          }
        },
        { root: null, rootMargin: '240px', threshold: 0 }
      )
      this.$nextTick(() => {
        if (this.$refs.scrollSentinel) {
          this.scrollObserver.observe(this.$refs.scrollSentinel)
        }
      })
    },
    teardownScrollObserver () {
      if (this.scrollObserver) {
        this.scrollObserver.disconnect()
        this.scrollObserver = null
      }
      window.removeEventListener('scroll', this.onWindowScroll)
    },
    onWindowScroll () {
      const nearBottom =
        window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 280
      if (nearBottom) this.loadMore()
    },
    observeSentinel () {
      this.$nextTick(() => {
        if (this.scrollObserver && this.$refs.scrollSentinel) {
          this.scrollObserver.disconnect()
          this.scrollObserver.observe(this.$refs.scrollSentinel)
        }
      })
    },
    resetAndFetch () {
      this.currentPage = 1
      this.finished = false
      this.isSearchResults = false
      this.items = []
      this.fetchItems({ append: false })
    },
    loadMore () {
      if (
        this.callDeliveryComponent ||
        this.isSearchResults ||
        this.finished ||
        this.loadingMore ||
        this.$root.fullscreenLoading
      ) {
        return
      }
      if (this.items.length >= this.totalRecords && this.totalRecords > 0) {
        this.finished = true
        return
      }
      this.currentPage += 1
      this.fetchItems({ append: true })
    },
    openProgressDetailDialog (data) {
      this.progress_id = data
      this.$root.progressDetailDialog = true
    },
    checkProgressCode () {
      return (this.progressCode || []).some((element) => element !== 200)
    },
    groupDataByPhone () {
      if (!this.items || !this.items.length) {
        this.groupedData = {}
        return
      }
      this.groupedData = _.groupBy(this.items, 'phone_number')
    },
    checkAll () {
      if (this.formData.selectedTrackCodes.length === this.items.length) {
        this.formData.selectedTrackCodes = []
        this.formData.taviur_codes = []
        this.formData.phone_number = []
      } else {
        this.formData.selectedTrackCodes = this.items.map(item => item.track_code)
        this.formData.taviur_codes = this.items.map(item => item.taviur_code)
        this.formData.phone_number = this.items.map(item => item.phone_number)
      }
      this.handlePrice()
    },
    openProgressDialog (data, item) {
      if (data === 'one') {
        this.formData.selectedTrackCodes = [item.track_code]
        this.formData.is_paid = item.is_paid
        this.formData.paid_type = item.paid_type
        this.formData.totalPrice = item.price
        this.formData.taviur_codes = [item.taviur_code]
        this.formData.deliveryAmount = item.delivery_amount
        this.formData.description = item.description
        this.formData.jin = item.jin
        this.formData.user_status = item.status
        this.formData.save_price = item.save_price
      }
      this.formData.type = data
      if (this.progressCode[0] !== 200) {
        this.$root.progressDialog = true
      }
    },
    applyFilter (value) {
      this.transacProgressCode = value
      this.isSearchResults = false
      if (value === '130' || value === '140' || value === '210') {
        this.callDeliveryComponent = true
        this.items = []
        this.finished = true
      } else {
        this.callDeliveryComponent = false
        this.resetAndFetch()
      }
    },
    clearFilter () {
      this.transacProgressCode = null
      this.callDeliveryComponent = false
      this.resetAndFetch()
    },
    emitFunction () {
      this.transacProgressCode = null
      this.callDeliveryComponent = false
      this.resetAndFetch()
    },
    fetchItems ({ append = false } = {}) {
      if (this.callDeliveryComponent) {
        return Promise.resolve()
      }
      if (append) {
        this.loadingMore = true
      } else {
        this.$root.fullscreenLoading = true
        this.currentPage = 1
        this.finished = false
      }
      this.isSearchResults = false

      if (this.transacProgressCode != null && this.transacProgressCode !== '') {
        this.progress_code = this.transacProgressCode
      } else {
        this.progress_code = this.progressCode
      }

      const selectedParam = Array.isArray(this.progress_code)
        ? this.progress_code.join(',')
        : String(this.progress_code)

      return services
        .getTrackCodesApp(selectedParam, this.isPaid, this.currentPage, this.pageSize)
        .then((response) => {
          const rows = response.data || []
          const t = response.total
          this.totalRecords = typeof t === 'number' ? t : parseInt(t, 10) || 0

          if (append) {
            const existing = new Set(this.items.map(i => i.track_code || i.id))
            const fresh = rows.filter(r => !existing.has(r.track_code || r.id))
            this.items = this.items.concat(fresh)
          } else {
            this.items = rows
          }

          if (!rows.length || this.items.length >= this.totalRecords) {
            this.finished = true
          } else {
            this.finished = false
          }

          this.loadingMore = false
          this.$root.fullscreenLoading = false
          this.groupDataByPhone()
          this.observeSentinel()
        })
        .catch((error) => {
          console.error('Алдаа:', error)
          if (append) {
            this.currentPage = Math.max(1, this.currentPage - 1)
          }
          this.loadingMore = false
          this.$root.fullscreenLoading = false
          this.$notify({
            title: 'Алдаа',
            message: error && error.message ? error.message : String(error),
            type: 'error'
          })
        })
    },
    searchItemDelivery () {
      const child = this.$refs.deliveryComponent
      if (child && typeof child.getDeliveryList === 'function') {
        child.search_query = this.searchQuery
        child.getDeliveryList()
      }
    },
    async searchItem () {
      if (!this.searchQuery) {
        return this.resetAndFetch()
      }
      this.$root.fullscreenLoading = true
      this.isSearchResults = true
      this.finished = true
      this.currentPage = 1
      const codes = this.transacProgressCode || this.progressCode
      services.trackCodeSearch(this.isPaid, codes, this.searchQuery)
        .then((response) => {
          const rows = response.data || []
          this.items = rows
          this.totalRecords = rows.length
          this.$root.fullscreenLoading = false
          this.groupDataByPhone()
        })
        .catch((error) => {
          this.$root.fullscreenLoading = false
          this.$notify({
            title: 'Алдаа',
            message: error && error.message ? error.message : String(error),
            type: 'error'
          })
        })
    },
    clearSearch () {
      this.searchQuery = ''
      this.resetAndFetch()
    },
    handlePrice (data) {
      this.formData.totalPrice = 0
      this.formData.countTrackCode = 0
      this.formData.deliveryAmount = 0
      this.formData.save_price = 0

      this.items.forEach(element => {
        this.formData.selectedTrackCodes.forEach(elementTrackCode => {
          if (element.track_code === elementTrackCode) {
            this.formData.totalPrice = (element.price || 0) + this.formData.totalPrice
            this.formData.deliveryAmount += (element.delivery_price || 0)
            this.formData.save_price += (element.save_price || 0)
            this.formData.countTrackCode++
          }
        })
      })
      if (data) {
        if (this.formData.selectedTrackCodes.includes(data.track_code)) {
          if (!this.formData.taviur_codes.includes(data.taviur_code)) {
            this.formData.taviur_codes.push(data.taviur_code)
          }
          if (!this.formData.phone_number.includes(data.phone_number)) {
            this.formData.phone_number.push(data.phone_number)
          }
        } else {
          const index = this.formData.taviur_codes.indexOf(data.taviur_code)
          if (index !== -1) {
            this.formData.taviur_codes.splice(index, 1)
            this.formData.phone_number.splice(index, 1)
          }
        }
      }
    },
    returnStatusValue (data) {
      const result = (this.$root.statusArray || []).find(element => element.value === data)
      return result ? result.label : 'empty'
    },
    statusTagType (status) {
      const map = {
        180: 'danger',
        200: 'success',
        130: 'warning',
        140: 'info',
        150: '',
        160: 'warning',
        170: 'info'
      }
      return map[status] !== undefined ? map[status] : ''
    },
    statusAccentClass (status) {
      const map = {
        180: 'danger',
        200: 'success',
        130: 'warning',
        140: 'info',
        150: 'primary',
        160: 'warning',
        170: 'muted'
      }
      return map[status] || 'muted'
    },
    checkTypeLabel (type) {
      const map = {
        new: 'Үүсгэсэн',
        to_ereen: 'Эрээн салбарт шилжүүлсэн',
        to_user: 'Хэрэглэгч рүү шилжүүлсэн',
        to_mongol: 'Монгол салбарт шилжүүлсэн',
        from_user: 'Хэрэглэгч хариу ирүүлсэн'
      }
      return map[type] || type
    },
    checkPermissionsPage (data) {
      return checkPermissions(data)
    }
  }
}
</script>

<style scoped>
.tc-page {
  max-width: 640px;
  margin: 0 auto;
  padding: 16px 14px 28px;
  background: linear-gradient(180deg, #f1f5f9 0%, #f8fafc 40%, #fff 100%);
  min-height: 100%;
}

.tc-page__hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.tc-page__title {
  margin: 0;
  font-size: 1.45rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.tc-page__subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  color: #64748b;
}

.tc-page__count {
  flex-shrink: 0;
  text-align: right;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 8px 12px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
}

.tc-page__count-num {
  display: block;
  font-size: 1.25rem;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.2;
}

.tc-page__count-label {
  font-size: 11px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.tc-page__toolbar {
  margin-bottom: 14px;
}

.tc-page__search {
  display: flex;
  gap: 8px;
  align-items: center;
}

.tc-page__search .el-input {
  flex: 1;
}

.tc-page__filters {
  margin-bottom: 14px;
}

.tc-page__filters-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
  margin-bottom: 8px;
}

.tc-page__filter-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tc-chip {
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  padding: 7px 12px;
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.tc-chip:hover {
  border-color: #94a3b8;
  color: #0f172a;
}

.tc-chip--active {
  background: #0f172a;
  border-color: #0f172a;
  color: #fff;
}

.tc-page__actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
  padding: 12px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
}

.tc-page__actions .el-button {
  margin: 0 !important;
  width: 100%;
  border-radius: 10px !important;
}

.tc-page__summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  font-size: 13px;
  color: #475569;
}

.tc-page__summary-right {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}

.tc-check-all >>> .el-checkbox__inner {
  width: 18px;
  height: 18px;
}

.tc-card-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tc-card {
  border-radius: 14px !important;
  overflow: hidden;
  border: 1px solid #e2e8f0 !important;
  position: relative;
}

.tc-card__accent {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #94a3b8;
}

.tc-card__accent--success { background: #10b981; }
.tc-card__accent--warning { background: #f59e0b; }
.tc-card__accent--danger { background: #ef4444; }
.tc-card__accent--primary { background: #3b82f6; }
.tc-card__accent--info { background: #6366f1; }
.tc-card__accent--muted { background: #94a3b8; }

.tc-card__body {
  padding: 14px 14px 12px 18px;
}

.tc-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.tc-card__code {
  font-size: 1.05rem;
  font-weight: 600;
  color: #0f172a;
  word-break: break-all;
}

.tc-card__check {
  display: flex !important;
  align-items: flex-start;
}

.tc-card__check >>> .el-checkbox__label {
  font-size: 1.05rem;
  font-weight: 600;
  color: #0f172a;
  white-space: normal;
  line-height: 1.3;
}

.tc-card__check >>> .el-checkbox__inner {
  width: 20px;
  height: 20px;
}

.tc-card__tag {
  flex-shrink: 0;
  border-radius: 8px !important;
}

.tc-card__meta {
  cursor: pointer;
}

.tc-card__date {
  display: block;
  font-size: 12px;
  color: #94a3b8;
  margin-bottom: 8px;
}

.tc-card__dl {
  margin: 0;
}

.tc-card__row {
  display: grid;
  grid-template-columns: 88px 1fr;
  gap: 4px 10px;
  padding: 4px 0;
  border-bottom: 1px solid #f1f5f9;
  font-size: 13px;
}

.tc-card__row:last-child {
  border-bottom: none;
}

.tc-card__row dt {
  margin: 0;
  color: #94a3b8;
}

.tc-card__row dd {
  margin: 0;
  color: #334155;
  word-break: break-word;
}

.tc-card__phone {
  color: #2563eb;
  text-decoration: none;
  font-weight: 500;
}

.tc-user--new { color: #059669; font-weight: 500; }
.tc-user--old { color: #d97706; font-weight: 500; }
.tc-user--none { color: #dc2626; font-weight: 500; }

.tc-card__footer {
  margin-top: 12px;
}

.tc-card__btn {
  width: 100%;
  border-radius: 10px !important;
}

.tc-page__scroll-status {
  margin-top: 14px;
  text-align: center;
  font-size: 13px;
  color: #64748b;
  padding: 10px 8px 4px;
}

.tc-page__loading-more {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #3b82f6;
}

.tc-scroll-loader {
  position: fixed;
  left: 50%;
  bottom: 88px;
  transform: translateX(-50%);
  z-index: 2000;
  pointer-events: none;
}

.tc-scroll-loader__inner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 18px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.92);
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.28);
  white-space: nowrap;
}

.tc-scroll-loader__icon {
  font-size: 18px;
}

.tc-fade-enter-active,
.tc-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.tc-fade-enter,
.tc-fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(8px);
}

.tc-page__end {
  color: #94a3b8;
}

.tc-page__hint {
  color: #94a3b8;
  font-size: 12px;
}

.tc-page__sentinel {
  height: 1px;
  width: 100%;
  pointer-events: none;
}

.tc-page__empty {
  padding: 40px 0;
}
</style>
